// LOGISPRD-12506 (어드민 편입) — 온콜 콘솔 진입 주소.
//
// 예전에는 배포 형태마다 진입 경로가 달라서(`/console.html` · caddy 의 `/console/console.html` ·
// 로컬 4100 직접) `resolveConsoleEntryUrl(isDev, port)` 로 갈랐다. 콘솔이 어드민 라우트가 되면서
// 그 분기가 전부 사라졌다 — 어디서 열리든 같은 문서 안의 해시 이동이다.
//
// 왜 경로(`/console`)가 아니라 해시인가: 배포 호스트의 CDN 이 `/` 외의 경로를 전부 API 오리진으로
// 보내기 때문이다. 경로로 만들면 새로고침·북마크·주소 공유가 전부 게이트웨이의 401 JSON 으로
// 떨어진다. 해시는 서버로 전송되지 않아 경로가 항상 `/` 로 유지된다. 자세한 배경은
// `src/console/shell/ConsolePage.tsx` 상단 주석 참고.
export const CONSOLE_HASH_ROOT = 'console'

export const CONSOLE_ENTRY_URL = `/#${CONSOLE_HASH_ROOT}`

/**
 * 이 해시가 콘솔 화면을 가리키는가. 어드민 라우팅(`App.tsx` 의 `ConsoleHashGate`)이 이 판정으로
 * 콘솔을 띄운다. 탭까지 포함한 형태(`#console/fopt`)도 콘솔이다.
 *
 * 판정이 `@/console/*` 이 아니라 여기 있는 이유 — `App.tsx` 는 어드민 메인 번들이고, 콘솔은 지연
 * 청크다. 판정 함수를 콘솔 쪽에 두면 그것 하나 때문에 콘솔 모듈이 메인 번들로 끌려 들어온다.
 */
export const isConsoleHash = (hash: string): boolean => {
  const value = hash.replace(/^#/, '')
  return value === CONSOLE_HASH_ROOT || value.startsWith(`${CONSOLE_HASH_ROOT}/`)
}

// LOGISPRD-12506 — 온콜 콘솔 접근 게이트(사용자 확정 결정, 검수 지적으로 추가).
//
// 콘솔은 개발자 전용 화면이다. 핸드오프(§2.3 권한 매트릭스)에서 대부분의 조치 API 는
// `@devOpsGate` 로 보호되고, 플래그(`devops.consoleAuthz.enable`)가 켜지면 `AUTH_CD = MOMS_ENG`
// 만 통과한다. 판별은 정확히 그 값과 일치하는지만 본다 — 화주코드 접두사 없는 단독값이다(`MASTER`
// 와 같은 형태, `AuthStorage.user.get().auth` 가 그 원본이다. `MainHeader.tsx` 가 이미
// `userInfo.auth === 'MASTER'` 식으로 같은 필드를 쓰고 있다).
//
// ⚠️ 이 함수는 UX 게이트다. 보안 경계가 아니다 — 실제 차단은 BE `@devOpsGate` 이고, 그 플래그는
// 지금 dev·운영 모두 OFF 라서 API 는 이 함수와 무관하게 인증만 되면 누구나 호출할 수 있다.
// "프론트에서 막으니 안전하다"고 오해하지 말 것 — 여기서 막는 건 링크 노출과 콘솔 화면 렌더뿐이다.
export const CONSOLE_REQUIRED_AUTH_CD = 'MOMS_ENG'

export const hasConsoleAccess = (authCd: string | null | undefined): boolean => authCd === CONSOLE_REQUIRED_AUTH_CD
